// Assuming firebase config is in src/firebase.js
import {  } from '../firebase';
// import { sendPasswordResetEmail } from 'firebase/auth'; // This will be handled by our server

// Use process.env for Create React App environment variables
// No longer need Resend API key directly in the frontend

// Function to get the API base URL (runtime check based on hostname)
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  console.log('Current hostname:', hostname);
  
  // Check the hostname where the script is running in the browser
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // We are running locally
    return 'http://localhost:3001';
  } else if (hostname === 'newreports.apexionx.com') {
    // Frontend is at newreports.apexionx.com, backend at reportsnew.apexionx.com
    return 'https://reportsnew.apexionx.com';
  } else {
    // The current app is deployed at reportsnew.apexionx.com
    // In this case, we should use the same origin since frontend and backend are at the same domain
    return window.location.origin;
  }
};

// Use our server API for password reset instead of direct Firebase call
export const sendPasswordResetEmail = async (email) => {
  try {
    console.log('Sending password reset request to server for email:', email);
    const apiBase = getApiBaseUrl();
    const endpoint = apiBase.endsWith('/api') ? '/send-reset-email' : '/api/send-reset-email';
    
    // Log full request URL for debugging
    const requestUrl = `${apiBase}${endpoint}`;
    console.log('Making API request to:', requestUrl);
    
    // Call our server API endpoint instead of Firebase directly
    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    console.log('Server response status:', response.status);
    
    // Get the response data
    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      // Handle non-JSON responses to avoid parsing errors
      const text = await response.text();
      console.error("Received non-JSON response:", text.substring(0, 100) + "...");
      throw new Error("Received non-JSON response from server");
    }
    
    console.log('Server response data:', data);

    if (!response.ok) {
      throw new Error(data.message || 'Failed to send password reset email');
    }
    
    console.log('Password reset email sent via server API');
    return data;
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

// Legacy name for backward compatibility
export const sendPasswordResetEmailWithResend = sendPasswordResetEmail;

// You can keep this function for other email services like contact forms
export const sendContactEmailWithResend = async (name, email, subject, message) => {
  try {
    const apiBase = getApiBaseUrl();
    const endpoint = apiBase.endsWith('/api') ? '/send-contact-email' : '/api/send-contact-email';
    const requestUrl = `${apiBase}${endpoint}`;
    
    console.log('Making contact email API request to:', requestUrl);
    
    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email, subject, message }),
    });

    // Check content type before parsing JSON
    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      // Handle non-JSON responses
      const text = await response.text();
      console.error("Received non-JSON response:", text.substring(0, 100) + "...");
      throw new Error("Received non-JSON response from server");
    }

    if (!response.ok) {
      throw new Error(data.message || 'Failed to send contact email');
    }

    return data;
  } catch (error) {
    console.error('Error sending contact email:', error);
    throw error;
  }
};

// You might also want to keep the standard Firebase password reset function available
// import { sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';

// export const sendPasswordResetEmailWithFirebase = async (email) => {
//   try {
//     await firebaseSendPasswordResetEmail(auth, email);
//     console.log('Password reset email sent successfully via Firebase.');
//   } catch (error) {
//     console.error('Error sending password reset email via Firebase:', error);
//     throw error;
//   }
// };

// Add a test function to check if Resend is configured on the server
export const testResendConfiguration = async () => {
  try {
    const apiBase = getApiBaseUrl();
    const endpoint = apiBase.endsWith('/api') ? '/test-resend' : '/api/test-resend';
    const requestUrl = `${apiBase}${endpoint}`;
    
    console.log('Making test-resend API request to:', requestUrl);
    
    const response = await fetch(requestUrl);
    
    // Check content type before parsing JSON
    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      // Handle non-JSON responses
      const text = await response.text();
      console.error("Received non-JSON response from test-resend:", text.substring(0, 100) + "...");
      throw new Error("Received non-JSON response from server");
    }
    
    console.log('Resend configuration test result:', data);
    return data;
  } catch (error) {
    console.error('Error testing Resend configuration:', error);
    throw error;
  }
};

// Add a test function to check if Firebase Admin is configured on the server
export const testFirebaseConfiguration = async () => {
  try {
    const apiBase = getApiBaseUrl();
    const endpoint = apiBase.endsWith('/api') ? '/test-firebase' : '/api/test-firebase';
    const requestUrl = `${apiBase}${endpoint}`;
    
    console.log('Testing Firebase Admin SDK configuration at:', requestUrl);
    
    const response = await fetch(requestUrl);
    
    // Check content type before parsing JSON
    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      // Handle non-JSON responses
      const text = await response.text();
      console.error("Received non-JSON response from test-firebase:", text.substring(0, 100) + "...");
      throw new Error("Received non-JSON response from server");
    }
    
    console.log('Firebase Admin configuration test result:', data);
    return data;
  } catch (error) {
    console.error('Error testing Firebase Admin configuration:', error);
    throw error;
  }
};